<template>
  <div class="sky-hc-setting">
    <el-form label-position="top" :model="insideConfigForm" :rules="rules">
      <el-form-item :label="$t('setting.banner')" prop="bannerImg" verify>
        <Upload
          uploadClass="sky-hc-upload__uploader-index"
          :imgUrl="insideConfigForm.bannerImg"
          @handleUploadFile="handleUploadFile"
        ></Upload>
      </el-form-item>
      <el-form-item :label="$t('setting.linkAddress')" prop="bannerLink" verify>
        <el-input v-model="insideConfigForm.bannerLink"></el-input>
      </el-form-item>
    </el-form>
    <div class="sky-hc-setting__inner-menus">
      <div class="sky-hc-setting__inner-menus-tit">{{ $t('setting.menucontent', { num: maxNum }) }}</div>
      <div class="sky-hc-setting__inner-checked-menus">
        <el-tag
          v-for="(tag, index) in seletedCategorys"
          :key="tag.categoryId"
          closable
          @close="handleDelMenuItem(tag, index)"
          effect="plain"
          class="sky-hc-setting__inner-menu-item"
        >
          {{ tag.categoryName }}
        </el-tag>
      </div>
    </div>
    <div class="sky-hc-setting__category" v-for="(item, index) in categoryList" :key="index">
      <span
        class="sky-hc-setting__category-item"
        v-for="(subItem, subIndex) in item"
        :key="'0' + subIndex"
        @click="handleChooseCategory(subItem)"
        :class="subItem.checked ? 'sky-hc-setting__category-item--active' : ''"
      >
        {{ subItem.name }}
      </span>
    </div>
    <div class="sky-hc-setting__btns">
      <el-button class="sky-hc-setting__btn" @click="handleCancel">{{ $t('cancel') }}</el-button>
      <el-button class="sky-hc-setting__btn" type="primary" @click="handleSetInsidePageConfig">{{
        $t('articleManage.save')
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { Form, FormItem, Input, Button, Tag } from 'element-ui'

import { getCategoryList } from '@/api/articleManage'
import { getInsidePageSetting, setInsidePageSetting } from '@/api/setting'

import Upload from '@/components/upload'
import { CATEGORY_TYPE } from '@/utils/enum'
import { FormValidate } from '@/utils/formValidate'

export default {
  name: 'IndexSetting',
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tag.name]: Tag,
    Upload
  },
  computed: {},
  data() {
    return {
      categoryList: [],
      activeIndex: [],
      maxNum: 6,
      seletedCategorys: [],
      insideConfigForm: {
        bannerImg: '',
        bannerLink: '',
        quickLinks: []
      },
      rules: {
        bannerLink: [
          [
            {
              validator: FormValidate.validateURL
            }
          ]
        ]
      }
    }
  },
  created() {
    this.handleGetCategoryList()
  },
  methods: {
    handleGetCategoryList() {
      getCategoryList({ type: CATEGORY_TYPE.ARTICLE }).then(response => {
        const data = response.data.content.itemArr
        const categoryList = []
        for (let i = 0; i < data.length; i++) {
          let categorySubList = []
          categorySubList.push(Object.assign(data[i], { checked: false }))
          if (data[i].children && data[i].children.length) {
            for (let j = 0; j < data[i].children.length; j++) {
              categorySubList.push(Object.assign(data[i].children[j], { checked: false }))
            }
          }
          categoryList.push(categorySubList)
        }
        this.categoryList = categoryList
        this.handleGetInsidePageConfig()
      })
    },
    handleChooseCategory(subItem) {
      if (this.seletedCategorys.length >= 6 || subItem.checked) return
      subItem.checked = true
      this.seletedCategorys.push({
        categoryId: subItem.id,
        categoryName: subItem.name
      })
    },
    handleUploadFile(url) {
      this.$set(this.insideConfigForm, 'bannerImg', url)
    },
    handleGetInsidePageConfig() {
      getInsidePageSetting().then(response => {
        const data = response.data.content
        if (data.bannerImg === null) {
          data.bannerImg = ''
        }
        this.insideConfigForm = data
        this.seletedCategorys = []
        for (let i in this.categoryList) {
          for (let j in this.categoryList[i]) {
            this.categoryList[i][j].checked = false
            data.quickLinks.map(item => {
              if (item.categoryId === this.categoryList[i][j].id) {
                this.categoryList[i][j].checked = true
                this.seletedCategorys.push(item)
              }
            })
          }
        }
      })
    },
    handleSetInsidePageConfig() {
      setInsidePageSetting(
        Object.assign(this.insideConfigForm, {
          quickLinks: this.seletedCategorys
        })
      ).then(() => {
        this.handleGetInsidePageConfig()
      })
    },
    handleDelMenuItem(tag, index) {
      this.seletedCategorys.splice(index, 1)
      for (let i in this.categoryList) {
        for (let j in this.categoryList[i]) {
          if (this.categoryList[i][j].id === tag.categoryId) {
            this.categoryList[i][j].checked = false
            break
          }
        }
      }
      this.categoryList.splice(0, 0)
    },
    handleCancel() {
      this.seletedCategorys = []
      this.handleGetInsidePageConfig()
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-setting) {
  @include e(inner-menus) {
    margin-top: 5px;
  }
  @include e(inner-menus-tit) {
    font-size: $--size-base;
    color: #333333;
    font-weight: bold;
    margin-bottom: 17px;
  }
  @include e(inner-menu-item) {
    margin-right: 20px;
    height: 30px;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 10px;
    line-height: 30px;
    background: rgba(59, 125, 253, 0.2);
    border-radius: 15px;
    border: 1px solid #3b7dfd;
    color: #3b7dfd;
    font-size: $--size-base;
    .el-icon-close {
      color: #3b7dfd;
      font-size: $--size-base;
      &:hover {
        color: #3b7dfd;
      }
    }
  }
}
</style>
